/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetTabloProjectsQueryVariables = Exact<{
  organizationId: string;
  isTemplate: boolean;
  contextId?: string | null | undefined;
}>;

export type GetTabloProjectsQuery = {
  getTabloProjects: Array<{
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    zalamoPrintSizeId: string | null;
    isRented: boolean | null;
    sourcePaidTemplateId: string | null;
  } | null> | null;
};

export type TabloDetailsFragment = {
  tabloProjectId: string | null;
  name: string | null;
  type: Types.TabloType | null;
  width: number | null;
  height: number | null;
  isDeleted: boolean | null;
  isFromLab: boolean | null;
  labProductId: string | null;
  pages: Array<string | null>;
  faceMatchConfig: string | null;
  lastHistoryEntryId: string | null;
  created: number | null;
  isValid: boolean | null;
  hasLeadingChild: boolean | null;
  leadingChildId: string | null;
  subProjectsCount: number | null;
  parentProjectId: string | null;
  proofingWaitsForPhotographer: boolean | null;
  sentForProofing: boolean | null;
  zalamoPrintSizeId: string | null;
};

export type GetTabloProjectQueryVariables = Exact<{
  tabloProjectId: string;
}>;

export type GetTabloProjectQuery = {
  getTabloProject: {
    tabloProjectId: string | null;
    name: string | null;
    type: Types.TabloType | null;
    width: number | null;
    height: number | null;
    isDeleted: boolean | null;
    isFromLab: boolean | null;
    labProductId: string | null;
    pages: Array<string | null>;
    faceMatchConfig: string | null;
    lastHistoryEntryId: string | null;
    created: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    leadingChildId: string | null;
    subProjectsCount: number | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    sentForProofing: boolean | null;
    zalamoPrintSizeId: string | null;
  } | null;
};

export type CreateTabloProjectMutationVariables = Exact<{
  organizationId: string;
  input: Types.TabloProjectInput;
  tabloProjectId: string;
}>;

export type CreateTabloProjectMutation = {
  createTabloProject: {
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
  } | null;
};

export type CloneTabloTemplateMutationVariables = Exact<{
  tabloProjectId: string;
  name: string;
  templateId: string;
  width: number;
  height: number;
  type: Types.TabloType;
  organizationId: string;
}>;

export type CloneTabloTemplateMutation = {
  cloneTabloTemplate: {
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    pages: Array<string | null>;
  } | null;
};

export type UpdateTabloProjectMutationVariables = Exact<{
  tabloProjectId: string;
  input: Types.TabloProjectInput;
}>;

export type UpdateTabloProjectMutation = {
  updateTabloProject: {
    tabloProjectId: string | null;
    name: string | null;
    type: Types.TabloType | null;
    width: number | null;
    height: number | null;
    isDeleted: boolean | null;
    isFromLab: boolean | null;
    labProductId: string | null;
    pages: Array<string | null>;
    faceMatchConfig: string | null;
    lastHistoryEntryId: string | null;
    created: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    leadingChildId: string | null;
    subProjectsCount: number | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    sentForProofing: boolean | null;
    zalamoPrintSizeId: string | null;
  } | null;
};

export type CreateTabloProjectFromTemplateMutationVariables = Exact<{
  tabloProjectId: string;
  name: string;
  templateId: string;
  contextId: string;
  zalamoPrintSizeId?: string | null | undefined;
  targetWidth?: number | null | undefined;
  targetHeight?: number | null | undefined;
}>;

export type CreateTabloProjectFromTemplateMutation = {
  createTabloProjectFromTemplate: {
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    pages: Array<string | null>;
    faceMatchConfig: string | null;
    proofingOrganizationMemberId: string | null;
    sentForProofing: boolean | null;
    proofingWaitsForPhotographer: boolean | null;
    zalamoPrintSizeId: string | null;
    zalamoPrintOrderForPhotographerId: string | null;
  } | null;
};

export type CreateTabloTemplateFromProjectMutationVariables = Exact<{
  sourceTabloProjectId: string;
  tabloProjectId: string;
  organizationId: string;
  name: string;
}>;

export type CreateTabloTemplateFromProjectMutation = {
  createTabloTemplateFromProject: {
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    sourcePaidTemplateId: string | null;
  } | null;
};

export type GetTabloProjectsForContextQueryVariables = Exact<{
  contextId: string;
}>;

export type GetTabloProjectsForContextQuery = {
  getProjectsForContext: Array<{
    type: Types.TabloType | null;
    name: string | null;
    isDeleted: boolean | null;
    height: number | null;
    tabloProjectId: string | null;
    width: number | null;
    created: number | null;
    hasLeadingChild: boolean | null;
    isValid: boolean | null;
    leadingChildId: string | null;
    parentProjectId: string | null;
    subProjectsCount: number | null;
    proofingOrganizationMemberId: string | null;
    sentForProofing: boolean | null;
    proofingWaitsForPhotographer: boolean | null;
    zalamoPrintSizeId: string | null;
    zalamoPrintOrderForPhotographerId: string | null;
    needsRendering: boolean | null;
    photoToReplaceCount: number | null;
    isRented: boolean | null;
    sourcePaidTemplateId: string | null;
  } | null> | null;
};

export type DownloadTabloProjectsQueryVariables = Exact<{
  tabloProjectIds: Array<string> | string;
}>;

export type DownloadTabloProjectsQuery = {
  downloadTabloProjects: string | null;
};

export type GenerateAllOtherChildrenMutationVariables = Exact<{
  tabloProjectId: string;
}>;

export type GenerateAllOtherChildrenMutation = {
  generateAllOtherChildren: { status: boolean | null } | null;
};

export type SendTabloToProofingMutationVariables = Exact<{
  tabloProjectId: string;
  organizationMemberId: string;
}>;

export type SendTabloToProofingMutation = {
  sendTabloToProofing: {
    tabloProjectId: string | null;
    proofingOrganizationMemberId: string | null;
    sentForProofing: boolean | null;
  } | null;
};

export type ApplyProofingMutationVariables = Exact<{
  tabloProjectId: string;
}>;

export type ApplyProofingMutation = {
  applyProofing: {
    tabloProjectId: string | null;
    name: string | null;
    type: Types.TabloType | null;
    width: number | null;
    height: number | null;
    isDeleted: boolean | null;
    isFromLab: boolean | null;
    labProductId: string | null;
    pages: Array<string | null>;
    faceMatchConfig: string | null;
    lastHistoryEntryId: string | null;
    created: number | null;
    isValid: boolean | null;
    hasLeadingChild: boolean | null;
    leadingChildId: string | null;
    subProjectsCount: number | null;
    parentProjectId: string | null;
    proofingWaitsForPhotographer: boolean | null;
    sentForProofing: boolean | null;
    zalamoPrintSizeId: string | null;
  } | null;
};

export type RevokeProofingMutationVariables = Exact<{
  tabloProjectId: string;
}>;

export type RevokeProofingMutation = {
  revokeProofing: {
    tabloProjectId: string | null;
    proofingOrganizationMemberId: string | null;
    sentForProofing: boolean | null;
  } | null;
};

export type GenerateMockupFromProjectMutationVariables = Exact<{
  projectId: string;
  ageLevel?: number | null | undefined;
  numStudents?: number | null | undefined;
  organizationName?: string | null | undefined;
  organizationGroupName?: string | null | undefined;
  schoolLogo?: string | null | undefined;
  childStaticPhotos?:
    Array<string | null | undefined> | string | null | undefined;
  schoolPhotos?: Array<string | null | undefined> | string | null | undefined;
}>;

export type GenerateMockupFromProjectMutation = {
  generateMockupFromProject: string | null;
};

export type PlaceTemplateOrderMutationVariables = Exact<{
  templateId: string;
  isRent: boolean;
  organizationId: string;
  rentedForContextId?: string | null | undefined;
}>;

export type PlaceTemplateOrderMutation = { placeTemplateOrder: string | null };

export type ExportTablosToZalamoPrintMutationVariables = Exact<{
  tabloProjectIds: Array<string> | string;
  organizationId: string;
  tabloPrintType: Types.TabloPrintType;
}>;

export type ExportTablosToZalamoPrintMutation = {
  exportTablosToZalamoPrint: string | null;
};

export type SaveTabloMemberPhotoPositionMutationVariables = Exact<{
  input: Types.TabloMemberPhotoPositionInput;
}>;

export type SaveTabloMemberPhotoPositionMutation = {
  saveTabloMemberPhotoPosition: {
    tabloMemberPhotoPositionId: string;
    memberId: string;
    photoId: string;
    groupId: string;
    x: number;
    y: number;
    width: number;
    height: number;
    scale: number;
    rotation: number;
  } | null;
};

export type GetTabloMemberPhotoPositionQueryVariables = Exact<{
  memberId: string;
  contextId: string;
}>;

export type GetTabloMemberPhotoPositionQuery = {
  getTabloMemberPhotoPosition: {
    tabloMemberPhotoPositionId: string;
    memberId: string;
    photoId: string;
    groupId: string;
    contextId: string;
    x: number;
    y: number;
    width: number;
    height: number;
    scale: number;
    rotation: number;
  } | null;
};

export type GetTabloMemberPhotoPositionsQueryVariables = Exact<{
  memberIds: Array<string> | string;
  contextId: string;
}>;

export type GetTabloMemberPhotoPositionsQuery = {
  getTabloMemberPhotoPositions: Array<{
    tabloMemberPhotoPositionId: string;
    memberId: string;
    photoId: string;
    groupId: string;
    contextId: string;
    x: number;
    y: number;
    width: number;
    height: number;
    scale: number;
    rotation: number;
  } | null> | null;
};

export type DeleteTabloMemberPhotoPositionMutationVariables = Exact<{
  memberId: string;
  contextId: string;
}>;

export type DeleteTabloMemberPhotoPositionMutation = {
  deleteTabloMemberPhotoPosition: { status: boolean | null } | null;
};

export const TabloDetailsFragmentDoc = gql`
  fragment TabloDetails on TabloProject {
    tabloProjectId
    name
    type
    width
    height
    isDeleted
    isFromLab
    labProductId
    pages
    faceMatchConfig
    lastHistoryEntryId
    created
    isValid
    hasLeadingChild
    leadingChildId
    subProjectsCount
    parentProjectId
    proofingWaitsForPhotographer
    sentForProofing
    zalamoPrintSizeId
  }
`;
export const GetTabloProjectsDocument = gql`
  query getTabloProjects(
    $organizationId: ID!
    $isTemplate: Boolean!
    $contextId: ID
  ) {
    getTabloProjects(
      organizationId: $organizationId
      isTemplate: $isTemplate
      contextId: $contextId
    ) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      isValid
      hasLeadingChild
      parentProjectId
      proofingWaitsForPhotographer
      zalamoPrintSizeId
      isRented
      sourcePaidTemplateId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabloProjectsGQL extends Apollo.Query<
  GetTabloProjectsQuery,
  GetTabloProjectsQueryVariables
> {
  document = GetTabloProjectsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTabloProjectDocument = gql`
  query getTabloProject($tabloProjectId: ID!) {
    getTabloProject(tabloProjectId: $tabloProjectId) {
      ...TabloDetails
    }
  }
  ${TabloDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabloProjectGQL extends Apollo.Query<
  GetTabloProjectQuery,
  GetTabloProjectQueryVariables
> {
  document = GetTabloProjectDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTabloProjectDocument = gql`
  mutation createTabloProject(
    $organizationId: ID!
    $input: TabloProjectInput!
    $tabloProjectId: ID!
  ) {
    createTabloProject(
      organizationId: $organizationId
      input: $input
      tabloProjectId: $tabloProjectId
    ) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      isValid
      hasLeadingChild
      parentProjectId
      proofingWaitsForPhotographer
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTabloProjectGQL extends Apollo.Mutation<
  CreateTabloProjectMutation,
  CreateTabloProjectMutationVariables
> {
  document = CreateTabloProjectDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CloneTabloTemplateDocument = gql`
  mutation cloneTabloTemplate(
    $tabloProjectId: ID!
    $name: String!
    $templateId: ID!
    $width: Int!
    $height: Int!
    $type: TabloType!
    $organizationId: ID!
  ) {
    cloneTabloTemplate(
      tabloProjectId: $tabloProjectId
      name: $name
      templateId: $templateId
      width: $width
      height: $height
      type: $type
      organizationId: $organizationId
    ) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      isValid
      hasLeadingChild
      parentProjectId
      proofingWaitsForPhotographer
      pages
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CloneTabloTemplateGQL extends Apollo.Mutation<
  CloneTabloTemplateMutation,
  CloneTabloTemplateMutationVariables
> {
  document = CloneTabloTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateTabloProjectDocument = gql`
  mutation updateTabloProject(
    $tabloProjectId: ID!
    $input: TabloProjectInput!
  ) {
    updateTabloProject(tabloProjectId: $tabloProjectId, input: $input) {
      ...TabloDetails
    }
  }
  ${TabloDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateTabloProjectGQL extends Apollo.Mutation<
  UpdateTabloProjectMutation,
  UpdateTabloProjectMutationVariables
> {
  document = UpdateTabloProjectDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTabloProjectFromTemplateDocument = gql`
  mutation createTabloProjectFromTemplate(
    $tabloProjectId: ID!
    $name: String!
    $templateId: ID!
    $contextId: ID!
    $zalamoPrintSizeId: ID
    $targetWidth: Int
    $targetHeight: Int
  ) {
    createTabloProjectFromTemplate(
      tabloProjectId: $tabloProjectId
      name: $name
      templateId: $templateId
      contextId: $contextId
      targetHeight: $targetHeight
      targetWidth: $targetWidth
      zalamoPrintSizeId: $zalamoPrintSizeId
    ) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      pages
      faceMatchConfig
      proofingOrganizationMemberId
      sentForProofing
      proofingWaitsForPhotographer
      zalamoPrintSizeId
      zalamoPrintOrderForPhotographerId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTabloProjectFromTemplateGQL extends Apollo.Mutation<
  CreateTabloProjectFromTemplateMutation,
  CreateTabloProjectFromTemplateMutationVariables
> {
  document = CreateTabloProjectFromTemplateDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateTabloTemplateFromProjectDocument = gql`
  mutation createTabloTemplateFromProject(
    $sourceTabloProjectId: ID!
    $tabloProjectId: ID!
    $organizationId: ID!
    $name: String!
  ) {
    createTabloTemplateFromProject(
      sourceTabloProjectId: $sourceTabloProjectId
      tabloProjectId: $tabloProjectId
      organizationId: $organizationId
      name: $name
    ) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      isValid
      hasLeadingChild
      parentProjectId
      proofingWaitsForPhotographer
      sourcePaidTemplateId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateTabloTemplateFromProjectGQL extends Apollo.Mutation<
  CreateTabloTemplateFromProjectMutation,
  CreateTabloTemplateFromProjectMutationVariables
> {
  document = CreateTabloTemplateFromProjectDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTabloProjectsForContextDocument = gql`
  query getTabloProjectsForContext($contextId: ID!) {
    getProjectsForContext(contextId: $contextId) {
      type
      name
      isDeleted
      height
      tabloProjectId
      width
      created
      hasLeadingChild
      isValid
      leadingChildId
      parentProjectId
      subProjectsCount
      proofingOrganizationMemberId
      sentForProofing
      proofingWaitsForPhotographer
      zalamoPrintSizeId
      zalamoPrintOrderForPhotographerId
      needsRendering
      photoToReplaceCount
      isRented
      sourcePaidTemplateId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabloProjectsForContextGQL extends Apollo.Query<
  GetTabloProjectsForContextQuery,
  GetTabloProjectsForContextQueryVariables
> {
  document = GetTabloProjectsForContextDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DownloadTabloProjectsDocument = gql`
  query downloadTabloProjects($tabloProjectIds: [ID!]!) {
    downloadTabloProjects(tabloProjectIds: $tabloProjectIds)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DownloadTabloProjectsGQL extends Apollo.Query<
  DownloadTabloProjectsQuery,
  DownloadTabloProjectsQueryVariables
> {
  document = DownloadTabloProjectsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateAllOtherChildrenDocument = gql`
  mutation generateAllOtherChildren($tabloProjectId: ID!) {
    generateAllOtherChildren(tabloProjectId: $tabloProjectId) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateAllOtherChildrenGQL extends Apollo.Mutation<
  GenerateAllOtherChildrenMutation,
  GenerateAllOtherChildrenMutationVariables
> {
  document = GenerateAllOtherChildrenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendTabloToProofingDocument = gql`
  mutation sendTabloToProofing(
    $tabloProjectId: ID!
    $organizationMemberId: ID!
  ) {
    sendTabloToProofing(
      tabloProjectId: $tabloProjectId
      organizationMemberId: $organizationMemberId
    ) {
      tabloProjectId
      proofingOrganizationMemberId
      sentForProofing
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendTabloToProofingGQL extends Apollo.Mutation<
  SendTabloToProofingMutation,
  SendTabloToProofingMutationVariables
> {
  document = SendTabloToProofingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApplyProofingDocument = gql`
  mutation applyProofing($tabloProjectId: ID!) {
    applyProofing(tabloProjectId: $tabloProjectId) {
      ...TabloDetails
    }
  }
  ${TabloDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class ApplyProofingGQL extends Apollo.Mutation<
  ApplyProofingMutation,
  ApplyProofingMutationVariables
> {
  document = ApplyProofingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RevokeProofingDocument = gql`
  mutation revokeProofing($tabloProjectId: ID!) {
    revokeProofing(tabloProjectId: $tabloProjectId) {
      tabloProjectId
      proofingOrganizationMemberId
      sentForProofing
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RevokeProofingGQL extends Apollo.Mutation<
  RevokeProofingMutation,
  RevokeProofingMutationVariables
> {
  document = RevokeProofingDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GenerateMockupFromProjectDocument = gql`
  mutation generateMockupFromProject(
    $projectId: ID!
    $ageLevel: Int = 0
    $numStudents: Int = 5
    $organizationName: String
    $organizationGroupName: String
    $schoolLogo: String
    $childStaticPhotos: [String]
    $schoolPhotos: [String]
  ) {
    generateMockupFromProject(
      projectId: $projectId
      ageLevel: $ageLevel
      numStudents: $numStudents
      organizationName: $organizationName
      organizationGroupName: $organizationGroupName
      schoolLogo: $schoolLogo
      childStaticPhotos: $childStaticPhotos
      schoolPhotos: $schoolPhotos
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GenerateMockupFromProjectGQL extends Apollo.Mutation<
  GenerateMockupFromProjectMutation,
  GenerateMockupFromProjectMutationVariables
> {
  document = GenerateMockupFromProjectDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PlaceTemplateOrderDocument = gql`
  mutation placeTemplateOrder(
    $templateId: ID!
    $isRent: Boolean!
    $organizationId: ID!
    $rentedForContextId: ID
  ) {
    placeTemplateOrder(
      organizationId: $organizationId
      isRent: $isRent
      templateId: $templateId
      rentedForContextId: $rentedForContextId
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PlaceTemplateOrderGQL extends Apollo.Mutation<
  PlaceTemplateOrderMutation,
  PlaceTemplateOrderMutationVariables
> {
  document = PlaceTemplateOrderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ExportTablosToZalamoPrintDocument = gql`
  mutation exportTablosToZalamoPrint(
    $tabloProjectIds: [ID!]!
    $organizationId: ID!
    $tabloPrintType: TabloPrintType!
  ) {
    exportTablosToZalamoPrint(
      tabloProjectIds: $tabloProjectIds
      organizationId: $organizationId
      tabloPrintType: $tabloPrintType
    )
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ExportTablosToZalamoPrintGQL extends Apollo.Mutation<
  ExportTablosToZalamoPrintMutation,
  ExportTablosToZalamoPrintMutationVariables
> {
  document = ExportTablosToZalamoPrintDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SaveTabloMemberPhotoPositionDocument = gql`
  mutation saveTabloMemberPhotoPosition(
    $input: TabloMemberPhotoPositionInput!
  ) {
    saveTabloMemberPhotoPosition(input: $input) {
      tabloMemberPhotoPositionId
      memberId
      photoId
      groupId
      x
      y
      width
      height
      scale
      rotation
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SaveTabloMemberPhotoPositionGQL extends Apollo.Mutation<
  SaveTabloMemberPhotoPositionMutation,
  SaveTabloMemberPhotoPositionMutationVariables
> {
  document = SaveTabloMemberPhotoPositionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTabloMemberPhotoPositionDocument = gql`
  query getTabloMemberPhotoPosition($memberId: ID!, $contextId: ID!) {
    getTabloMemberPhotoPosition(memberId: $memberId, contextId: $contextId) {
      tabloMemberPhotoPositionId
      memberId
      photoId
      groupId
      contextId
      x
      y
      width
      height
      scale
      rotation
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabloMemberPhotoPositionGQL extends Apollo.Query<
  GetTabloMemberPhotoPositionQuery,
  GetTabloMemberPhotoPositionQueryVariables
> {
  document = GetTabloMemberPhotoPositionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTabloMemberPhotoPositionsDocument = gql`
  query getTabloMemberPhotoPositions($memberIds: [ID!]!, $contextId: ID!) {
    getTabloMemberPhotoPositions(memberIds: $memberIds, contextId: $contextId) {
      tabloMemberPhotoPositionId
      memberId
      photoId
      groupId
      contextId
      x
      y
      width
      height
      scale
      rotation
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTabloMemberPhotoPositionsGQL extends Apollo.Query<
  GetTabloMemberPhotoPositionsQuery,
  GetTabloMemberPhotoPositionsQueryVariables
> {
  document = GetTabloMemberPhotoPositionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteTabloMemberPhotoPositionDocument = gql`
  mutation deleteTabloMemberPhotoPosition($memberId: ID!, $contextId: ID!) {
    deleteTabloMemberPhotoPosition(
      tabloMemberPhotoPositionId: $memberId
      contextId: $contextId
    ) {
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteTabloMemberPhotoPositionGQL extends Apollo.Mutation<
  DeleteTabloMemberPhotoPositionMutation,
  DeleteTabloMemberPhotoPositionMutationVariables
> {
  document = DeleteTabloMemberPhotoPositionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
